export const environment = {
    production: true,
    apiUrl: 'https://eidsiva-api.slog.no',
    redirectUri: 'https://ebportal.slog.no/callback'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts